/**
 * DD Chat Module
 *
 * Exports for the Due Diligence Chat system.
 * Supports both MVP (prompt-based) and RAG implementations via strategy pattern.
 */

// Hook exports
export {
  useDDChat,
  useQuickAnalysis,
  profileToDDContext,
  addScoresToContext,
  type UseDDChatOptions,
  type UseDDChatReturn,
  type QuickAnalysisResult,
} from './use-dd-chat';

// UI types
export type {
  DDChatUIState,
  DDChatMessageProps,
  DDChatInputProps,
  DDChatContainerProps,
  DDQuickAction,
  DDMessageMetadataExtended,
  DDChatMessageExtended,
  DDChatAttachment,
} from './types';

export { DD_QUICK_ACTIONS } from './types';

// Strategy pattern types
export type {
  IDDAssistant,
  DDAssistantMode,
  DDSource,
  DDAssistantContext,
  DDAssistantResponse,
  DDAnalysisFocus,
  DDConversationSummary,
  DDConversation,
  DDAssistantConfig,
  RAGConfig,
  DDFeatureFlags,
} from './assistant.types';

export {
  DEFAULT_RAG_CONFIG,
  DEFAULT_DD_FEATURE_FLAGS,
  resolveAssistantMode,
} from './assistant.types';

// MVP Implementation
export { PromptBasedAssistant, createPromptBasedAssistant } from './prompt-based-assistant';

// RAG Implementation
export { RAGAssistant, createRAGAssistant } from './rag-assistant';

// Factory (main entry point)
export {
  createDDAssistant,
  createDDAssistantForUser,
  getDDAssistant,
} from './assistant-factory';

// Vector Store
export {
  storeDocumentChunks,
  deleteDocumentChunks,
  searchDocumentChunks,
  hybridSearchDocuments,
  createConversation,
  getConversations,
  storeConversationMessage,
  searchConversationHistory,
  updateConversationSummary,
  deleteConversation,
  searchResultsToSources,
  assembleContext,
} from './vector-store';

// Re-export types from edge-functions
export type {
  DDChatMessage,
  DDChatRole,
  DDStartupContext,
  DDChatRequest,
  DDChatResponse,
} from '@/lib/supabase/edge-functions';
